<template>
  <div>
    <div class="content-heading" v-if="!isHiddenAppTabs">
      <i class="ic-head-icon">
        <img
          src="@/assets/images/sidebar/products.svg"
          alt="Products"
          class="h-100"
        />
      </i>
      <h4 class="head-title">Products</h4>
      <i class="ic-tooltip" id="help"></i>
      <b-popover
        target="help"
        triggers="hover"
        content="Create your own product with multiple variations and wide ranges of add-ons. Manage and monitor your own product inventory."
      ></b-popover>
      <AppTabs :tabs="tabs" />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import AppTabs from "@/components/common/AppTabs.vue";
export default {
  components: {
    AppTabs,
  },
  data() {
    return {
      tabs: [
        {
          name: "Products",
          href: "/products/list",
          access: "estore-products.inventory:topup-estore",
        },
        {
          name: "Inventory",
          href: "/products/inventory",
          access: "estore-products.branch-inventory:topup-estore",
        },
      ],
    };
  },
  computed: {
    isHiddenAppTabs() {
      return this.$route.name === "CreateProduct" || this.$route.name === "UpdateProduct"
    }
  }
};
</script>
